import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import './output.css';
import App from './App';
import Login from './components/login/Login';
import Admin from './components/admin/Admin';
import List from './components/admin/List';
import BackfillCreatedAt from './components/admin/BackfillCreatedAt';
import { designsCollection } from './utils';
import { PrivateRoute, PublicOnlyRoute } from './components/PrivateRoute';
import reportWebVitals from './reportWebVitals';
import UserProvider from './providers/UserProvider';

ReactDOM.render(
    <React.StrictMode>
        <Router future={{ v7_relativeSplatPath: true }}>
            <UserProvider>
                <Routes>
                    <Route
                        path="/"
                        element={
                            <PublicOnlyRoute>
                                <Login />
                            </PublicOnlyRoute>
                        }
                    />
                    <Route
                        path="/login"
                        element={
                            <PublicOnlyRoute>
                                <Login />
                            </PublicOnlyRoute>
                        }
                    />
                    <Route path="/previsualizar/:productId" element={<App title="Stickapp" />} />
                    <Route
                        path="/admin/list/"
                        element={
                            <PrivateRoute>
                                <List title="Lista de diseños - Stickapp" />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/list/:page"
                        element={
                            <PrivateRoute>
                                <List title="Lista de diseños - Stickapp" />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/create"
                        element={
                            <PrivateRoute>
                                <Admin title="Crear nuevo diseño - Stickapp" />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/:designId"
                        element={
                            <PrivateRoute>
                                <Admin title="Editar diseño - Stickapp" />
                            </PrivateRoute>
                        }
                    />
                    {designsCollection === 'designs' && (
                        <Route
                            path="/admin/tools/backfill-created-at"
                            element={
                                <PrivateRoute>
                                    <BackfillCreatedAt />
                                </PrivateRoute>
                            }
                        />
                    )}
                </Routes>
            </UserProvider>
        </Router>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
